import React from 'react'
import Loader from './loader'
import _ from 'lodash';

class TextLoader extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      linesShown: [props.lines[0]]
    }
    this.animationIntervalSpeed = props.animationIntervalSpeed || 3000;
  }

  componentDidMount(){
    var that = this;
    this.animationInterval = window.setInterval(() => {
      var {linesShown} = that.state;
      if(linesShown.length < that.props.lines.length){
        var newLinesShown = _.concat(linesShown, [that.props.lines[linesShown.length]]);
        that.setState({
          linesShown: newLinesShown
        });
      } else{
        window.clearInterval(that.animationInterval);
      }
    }, this.animationIntervalSpeed)
  }

  componentWillUnmount(){
    window.clearInterval(this.animationInterval);
  }

  render(){
    var {linesShown} = this.state;
    return <div className="text-loader">
      {_.map(linesShown, (line, index) => {
        var showLoader = (index === linesShown.length - 1);
        return <div key={index} className={`fadeInDown mb-3 ${showLoader ? 'text-primary-9' : 'text-primary-5'}`}>{line}{showLoader && <Loader type="ellipsis" />}</div>
      })}
    </div>
  }

}

export default TextLoader;